* { box-sizing: border-box; }

.rating {
  display: flex;
  width: 100%;
  justify-content: start;
  overflow: hidden;
  flex-direction: row-reverse;
  position: relative;
  margin-top: 7px;
}

.rating-0 {
  filter: grayscale(100%);
}

.rating > input {
  display: none;
}

.rating > label {
  cursor: pointer;
  width: 30px;
  height: 30px;
  margin-top: auto;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='126.729' height='126.73'%3e%3cpath fill='%23e3e3e3' d='M121.215 44.212l-34.899-3.3c-2.2-.2-4.101-1.6-5-3.7l-12.5-30.3c-2-5-9.101-5-11.101 0l-12.4 30.3c-.8 2.1-2.8 3.5-5 3.7l-34.9 3.3c-5.2.5-7.3 7-3.4 10.5l26.3 23.1c1.7 1.5 2.4 3.7 1.9 5.9l-7.9 32.399c-1.2 5.101 4.3 9.3 8.9 6.601l29.1-17.101c1.9-1.1 4.2-1.1 6.1 0l29.101 17.101c4.6 2.699 10.1-1.4 8.899-6.601l-7.8-32.399c-.5-2.2.2-4.4 1.9-5.9l26.3-23.1c3.8-3.5 1.6-10-3.6-10.5z'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 76%;
  transition: .3s;
}

.rating > input:checked ~ label,
.rating > input:checked ~ label ~ label {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='126.729' height='126.73'%3e%3cpath fill='%23fcd93a' d='M121.215 44.212l-34.899-3.3c-2.2-.2-4.101-1.6-5-3.7l-12.5-30.3c-2-5-9.101-5-11.101 0l-12.4 30.3c-.8 2.1-2.8 3.5-5 3.7l-34.9 3.3c-5.2.5-7.3 7-3.4 10.5l26.3 23.1c1.7 1.5 2.4 3.7 1.9 5.9l-7.9 32.399c-1.2 5.101 4.3 9.3 8.9 6.601l29.1-17.101c1.9-1.1 4.2-1.1 6.1 0l29.101 17.101c4.6 2.699 10.1-1.4 8.899-6.601l-7.8-32.399c-.5-2.2.2-4.4 1.9-5.9l26.3-23.1c3.8-3.5 1.6-10-3.6-10.5z'/%3e%3c/svg%3e");
}


.rating > input:not(:checked) ~ label:hover,
.rating > input:not(:checked) ~ label:hover ~ label {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='126.729' height='126.73'%3e%3cpath fill='%23d8b11e' d='M121.215 44.212l-34.899-3.3c-2.2-.2-4.101-1.6-5-3.7l-12.5-30.3c-2-5-9.101-5-11.101 0l-12.4 30.3c-.8 2.1-2.8 3.5-5 3.7l-34.9 3.3c-5.2.5-7.3 7-3.4 10.5l26.3 23.1c1.7 1.5 2.4 3.7 1.9 5.9l-7.9 32.399c-1.2 5.101 4.3 9.3 8.9 6.601l29.1-17.101c1.9-1.1 4.2-1.1 6.1 0l29.101 17.101c4.6 2.699 10.1-1.4 8.899-6.601l-7.8-32.399c-.5-2.2.2-4.4 1.9-5.9l26.3-23.1c3.8-3.5 1.6-10-3.6-10.5z'/%3e%3c/svg%3e");
}


.feedback {
  font-size: small;
  width: 100%;
  padding: 6px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  box-shadow: 0 4px 30px rgba(0,0,0,.05);
  background: linear-gradient(#e5e5e5 0%,#485b69 100%);
  color: black;
  justify-content: space-around;
  p {
    font-size: small;
  }
  div {
    font-size: small;
  }
}


.steps {
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
  align-items: flex-end;
  width: 25%;
  @media (max-width: 1100px) {
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: baseline;  
  }
}


.info {
  display: flex;
  flex-wrap: wrap;
  font-weight: 900;
  flex-direction: column;
  padding: 20px;
  border-right: 1px solid white;
  width: 40%;
  @media (max-width: 811px) {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid white;
  }
}

.question {
  display: flex;
  flex-direction: column;
  width: 70%;
  @media (max-width: 1100px) {
    width: 100%;
  }
}

.questionsContainer {
  display: flex;
  padding: 20px;
  width: 55%;
  margin: 0 20px;
  @media (max-width: 1100px) {
    flex-direction: column;
  }
  @media (max-width: 811px) {
    width: 100%;
    margin: 12px 20px 12px 60px;
  }
}


.container {
  position: fixed;
  bottom: 0;
  z-index: 100;
  left: 0;
  width: -webkit-fill-available;
}

.close {
  position: absolute;
  right: 0;
  padding: 0.25rem;
  cursor: pointer;
}

.checkbox_options_wrapper {
  display: flex;
  flex-wrap: wrap;
  margin-top: 7px
}